function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLitecoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.215 2.566c-.137.461-.496 1.672-.805 2.688l-.55 1.851-.087.028c-.046.015-.335.11-.644.207l-.559.18-.136.48c-.075.262-.125.484-.118.492s.286-.07.614-.176c.324-.105.601-.187.605-.18.012.009-1.023 3.516-1.082 3.669-.012.027.668.035 3.34.035h3.348l.082-.27c.047-.144.175-.554.285-.91l.203-.652H8.44c-2.148 0-2.265-.004-2.257-.051.011-.023.183-.625.394-1.332L6.95 7.34l.594-.192.59-.191.14-.492c.079-.27.137-.492.137-.5-.004 0-.258.074-.562.172-.305.101-.563.18-.575.176-.007-.008.282-1.032.645-2.282.367-1.246.668-2.277.668-2.289s-.477-.02-1.059-.02H6.47Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "currentColor",
    fillOpacity: 1
  }
}));
export default SvgLitecoin;